import { State } from 'reducers';
import { BuildingOrg, OrgId } from 'shared/models';
import { createSelector } from 'reselect';
import { HasBuildingId } from './buildingsSelectors';

export type HasOrgId = {
    orgId: OrgId;
};

const emptyBuildingOrgs = Object.freeze<BuildingOrg[]>([]);

const getBuildingId = (state: State, props: Partial<HasBuildingId>) => props?.buildingId;

export const getAllBuildingOrgs = (state: State) => state.buildingOrgs.data;

export const getBuildingOrgs =
    createSelector(
        getAllBuildingOrgs,
        getBuildingId,
        (allBuildingOrgs, buildingId) =>
            allBuildingOrgs[buildingId!] || emptyBuildingOrgs
    )
;
